export class SpecialProductProject {
  public projectId: number;
  public isPrimaryProject: boolean;

  constructor(projectId: number, isPrimaryProject: boolean) {
    this.projectId = projectId;
    this.isPrimaryProject = isPrimaryProject;
  }
}
